import React from 'react';
import { Button, Form, Input, Select } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Header from '@components/Comman/Header';
import { SendOutlined } from '@ant-design/icons';
import { addSmsTemplate } from '../../actions/business';
import { smsTypeList } from '@utils/contstant';


const SmsForm = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const onFinish = (values: any) => {
        dispatch(
            addSmsTemplate(values,(resp: any) => {
                if (resp) {
                    navigate('/super-admin/sms');
                }
            })
        );
    };



    const onFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
        // You can also display an error message to the user here
    };

    return (
      <div>
        <Header pagTitle="Sms Template " />
        <div className='contentBody'>
          <div className="bodycard">
            <div className="bodycardheading">
              <div className="mobileView buttonsvgs" onClick={()=> navigate(-1)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                >
                  <rect
                    x="0.4"
                    y="1.18168"
                    width="23.2"
                    height="23.2"
                    rx="11.6"
                    stroke="#F47523"
                    strokeWidth="0.8"
                  />
                  <path
                    d="M14 8.78168L10 12.7817L14 16.7817"
                    stroke="#F47523"
                    strokeWidth="1.25"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              Edit Template
            </div>
            <div className="cardContentbody">
              <Form
                className="formControl"
                layout="vertical"
                form={form}
                onFinish={onFinish}
                onFinishFailed={onFailed}
                initialValues={{}}
              >
                <div className="row">
                  <div className="col-lg-12 col-sm-12">
                    <Form.Item
                      className="formControlDesign"
                      label="Title"
                      name="title"
                      rules={[{ required: true, message: 'Please input your  title!' }]}
                    >
                      <Select placeholder="Select SMS Type">
                        {smsTypeList?.map((item:any, index:number) => {
                          return (
                            <Select.Option value={item?.value} key={index}>{item.label}</Select.Option>
                          )
                        })}
                      </Select>
                    </Form.Item>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12 col-sm-12">
                    <Form.Item
                      className="formControlDesign"
                      label="body"
                      name="body"
                      rules={[{ required: true, message: 'Please input your body' }]}
                    >
                      <Input.TextArea placeholder='Body' rows={6}/>
                    </Form.Item>
                  </div>
                  <div className="col-lg-12 mt-15">
                    <div className="text-end btn-groups-Forms">
                      <button className="btn btn-outline-primary" onClick={() => navigate('/super-admin/sms')}>
                        Cancel
                      </button>
                      <Button className="btn btn-primary" type='primary' onClick={() => form.submit()}>
                        Update <SendOutlined />
                      </Button>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    );
};

export default SmsForm;
